<template>
  <a-row class="input" :gutter="12">
    <a-col :span="11">
      <!-- :getPopupContainer="(triggerNode) => triggerNode.parentNode" -->
      <a-select
        v-model:value="val.type"
        class="input__select"
        placeholder="Selecciona"
        :disabled="disabled"
        @change="handleChannelChange"
      >
        <a-select-option
          v-for="channel in channels"
          :key="channel?.id"
          :value="channel?.channel_id"
          :disabled="validateSMS() && channel?.channel_id === ChannelType.Sms"
        >
          <span>
            <icon-channel :type="channel?.channel_id" :src="channel?.channel_icon" :width="20" />
            {{ formatName(channel?.channel_name) }}
          </span>
        </a-select-option>
      </a-select>
    </a-col>
    <a-col v-if="showIdentifierInput" :span="11">
      <!-- :getPopupContainer="(triggerNode) => triggerNode.parentNode" -->
      <a-tooltip>
        <template #title v-if="identifierSelected">
          {{ tooltipDisabled && disabled ? tooltipDisabled : textIdentifier(identifierSelected) }}
        </template>
        <a-select
          v-model:value="val.id"
          class="input__select"
          placeholder="Selecciona"
          :disabled="disabled"
          @change="handleIdentifierChange"
        >
          <a-select-option
            v-for="identifier in identifiers"
            :key="identifier.id"
            :value="identifier.id"
            :disabled="
              ((val.identifier === identifier.id ||
                selectedValues.includes(identifier.id) ||
                identifier.is_associated_with_ivr_queue ||
                isBlockedForQueue(identifier) ||
                isBlockedForChatbot(identifier) ||
                !!blockedIdentifiers[identifier.id]
              ) && !toSequence) || 
                (selectedInclude(identifier.id) && toSequence)
            "
          >
            <a-tooltip placement="right">
              <template #title v-if="isBlockedForQueue(identifier) || isBlockedForChatbot(identifier) || blockedIdentifiers[identifier.id]">
                <span v-if="blockedIdentifiers[identifier.id]">
                  Este identificador ya está vinculado al Agente IA «{{ blockedIdentifiers[identifier.id] }}».
                </span>
                <span v-else-if="identifier.is_associated_queue">
                  Este identificador ya está vinculado a una cola.
                </span>
                <span v-else-if="identifier.is_associated_chatbot && !isBlockedForChatbot(identifier)">
                  Este identificador ya está vinculado a un chatbot.
                </span>
                <span v-else-if="identifier.is_associated_with_ivr_queue && !isBlockedForChatbot(identifier)">
                  Este identificador ya está vinculado a un IVR operador automático.
                </span>
              </template>
              <span>{{ textIdentifier(identifier)}}</span>
            </a-tooltip>
            <!-- <span v-if="val.type == ChannelType.Sms"> SMS </span>
            <span v-else-if="val.type !== ChannelType.Email">
              {{ identifier.alias || identifier.associate }}
              <template v-if="[ChannelType.Whatsapp, ChannelType.VoiceInbound, ChannelType.Sms].includes(val.type)">
                ({{ identifier.associate }})
              </template>
            </span>
            <span v-else>
              {{ identifier.associate || identifier.alias }}
              <template v-if="identifier.alias">
                ({{ identifier.alias }})
              </template>
            </span> -->
          </a-select-option>

          <template #dropdownRender v-if="identifiers?.length === 0">
            <div class="dropdown-default__wrapper">
              Este canal no tiene más identificadores disponibles
            </div>
          </template>
        </a-select>
      </a-tooltip>
    </a-col>
    <a-col span="1">
      <a-tooltip v-if="toSequence">
        <template #title v-if="!(showPop && !disabled) && showTooltipDelete">
          Este identificador tiene nodos configurados y no puede ser eliminado. Por favor, elimina o reconfigura los nodos asociados antes de intentar eliminar el identificador.
        </template>
        <a-button type="link" danger :disabled="!(showPop && !disabled)" style="padding: 0;">
          <DeleteOutlined
            style="margin-top: 10px;"
            @click="popChannel(val)"
          />  
        </a-button>
      </a-tooltip>
      <DeleteOutlined
        v-else-if="showPop && !disabled"
        style="margin-top: 10px; color: #ff0000"
        @click="popChannel(val)"
      />
    </a-col>
  </a-row>
</template>

<script>
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
import { ChannelMessage, ChannelVoice, ChannelType } from "@/app/shared/utils/enums";
import { defineComponent, ref, getCurrentInstance } from "vue";
import { DeleteOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    IconChannel,
    DeleteOutlined,
  },
  props: {
    /**
     * @property {number} value.id  id del Canal
     * @property {number} value.type id typo de Canal
     * @property {string} value.identifier Identificador
     */
    value: { required: false, type: Object, default: () => ({}) },
    items: { required: true, type: Array },
    showPop: { required: true, type: Boolean, default: false },
    selected: { required: false, type: Object, default: () => ({}) },
    withoutVoice: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    selectedValues: { type: Array, default: () => [] },
    showSms: { type: Boolean, default: false },
    toSequence: { type: Boolean, default: false },
    showTooltipDelete: { type: Boolean, default: false },
    chatAndVoiceInboundChannel: { type: Boolean, default: false },
    tooltipDisabled: { type: String, default: null },
    isQueue: {type: Boolean, default: false},
    isChatbot: {type: Boolean, default: false},
    /** Mapa id de identificador -> nombre del Agente IA que ya lo usa */
    blockedIdentifiers: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const val = ref(props.value);
    const component = getCurrentInstance();
    const selected = ref(props.selected);

    const selectedInclude = (id) => {
      // console.log(props.selectedValues, 'selected values')
      // console.log(id, 'id selected values')
      return props.selectedValues.filter(value => value !== null).includes(id);
    };

    const textIdentifier = (identifier) => {
      if (val.value.type == ChannelType.Sms)
        return "SMS";
      else if (val.value.type == ChannelType.Email) {
        let message = identifier.associate || identifier.alias;
        if (identifier.alias)
          message += ` (${identifier.alias})`;
        return message;
      } else {
        let message = identifier.associate || identifier.alias;
        if ([ChannelType.Whatsapp, ChannelType.VoiceInbound, ChannelType.Sms, ChannelType.WhatsappVoice].includes(val.value.type) && identifier.alias)
          message += ` (${identifier.alias})`;
        return message;
      }
    };

    const isMessageChannel = (channelId) =>{
      return ChannelMessage.includes(channelId);
    };

    const isVoiceChannel = (channelId) =>{
      return ChannelVoice.includes(channelId);
    };

    const disabledForQueue = (identifier) => {
      const id = identifier?.channel_id ?? val.value?.type;

      if (isMessageChannel(id)) {
        return !!(identifier?.is_associated_chatbot || identifier?.is_associated_queue);
      }

      if (isVoiceChannel(id)) {
        return !!(identifier?.is_associated_with_ivr_queue || identifier?.is_associated_queue);
      }

      // Fallback: si no pertenece a ninguno, solo considera la asociación a cola
      return !!identifier?.is_associated_queue;
    };

    const isBlockedForQueue = (identifier) =>{
      return !!(props.isQueue && disabledForQueue(identifier));
    };

    const isBlockedForChatbot = (identifier) =>{
      return !!(props.isChatbot && identifier?.is_associated_queue);
    };

    return {
      val,
      component,
      ChannelType,
      ChannelMessage,
      selected,
      selectedInclude,
      textIdentifier,
      isBlockedForQueue,
      isMessageChannel,
      isVoiceChannel,
      disabledForQueue,
      isBlockedForChatbot,
    };
  },
  computed: {
    identifiers() {
      // const items = this.items.filter(
      //   (item) =>
      //     item?.channel_id === this.value.type &&
      //     !this.selected.some(
      //       (itemSelected) =>
      //         itemSelected.identifier === item?.associate && itemSelected.type === item?.channel_id
      //     )
      // );
      // return items.map((item) => ({ alias: item.alias, associate: item.associate }));
      return this.items.filter((item) => item?.channel_id === this.value.type);
    },
    showIdentifierInput() {
      return this.val.type !== ChannelType.Sms || this.showSms;
    },
    channels() {
      // Filter all the channel items to just left one if they are repeated
      const notRepeatedChannels = this.items.filter(
        (v, i, a) => a.findIndex((t) => t?.channel_id === v?.channel_id) === i
      );

      const channels = notRepeatedChannels.filter((item) => item);

      console.log(channels, 'channels antes de filter')
      console.log(this.chatAndVoiceInboundChannel, 'this.chatAndVoiceInboundChannel');
      if (this.chatAndVoiceInboundChannel) {
        return channels.filter((channel) => {
          const channelId = channel.channel_id;

          return (
            (ChannelMessage.includes(channelId) &&
              ![ChannelType.Email, ChannelType.Sms].includes(channelId)) ||
            channelId == ChannelType.VoiceInbound
          );
        });
      }

      return this.withoutVoice
        ? channels.filter((channel) => ![ChannelType.VoiceInbound, ChannelType.WhatsappVoice].includes(channel.channel_id))
        : channels;
    },
    identifierSelected() {
      const items = this.items.filter((item) => item?.channel_id === this.value?.type);
      return items.find((item) => item?.id === this.value?.id);
    },
  },
  methods: {
    handleChannelChange(event) {
      this.val.identifier = undefined;
      this.val.type = event;
      let id = null;
      if (this.val.type === ChannelType.Sms) {
        id = this.items.find(this.compareType).id;
      }
      this.$emit("change", { index: this.component.vnode.key, id });
    },
    validateSMS() {
      return this.selected.some((channel) => channel.type === ChannelType.Sms);
    },
    handleIdentifierChange() {
      this.emitCustomerChannelId();
    },
    emitCustomerChannelId() {
      const items = this.items.filter((item) => item?.channel_id === this.value?.type);
      const item = items.find((item) => item.id === this.value?.id);
      console.log(item, 'identifier selected')
      if (item) {
        this.val.id = item?.id;
        this.$emit("change", { index: this.component.vnode.key, id: item?.id });
      }
    },
    compareType(item) {
      return item?.channel_id === this.value?.type;
    },
    popChannel(val) {
      this.$emit("popSlug", val);
    },
    formatName(name) {
      switch (name) {
        case "Telefonica":
          return "Voz";
        case "Messenger":
          return "Facebook Messenger";
        case "Chat Inbound":
          return "Web Chat";
        default:
          return name;
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.input
  margin: 0 !important
  margin-bottom: 12px !important

  &__select
    width: 100%

.dropdown-default__wrapper
  margin: 20px auto
  width: 190px
  text-align: center
  color: $gray-8
  font-size: 12px

.anticon-delete
  margin-top: 5px !important
  font-size: 20px
</style>
